<template>
  <b-row>
    <b-col cols="12">
      <n-h-r-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import NHRAddForm from './NHRAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    NHRAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
